import React, { useState } from "react";
import "./InteropEngineer.css";
import { Container } from "react-bootstrap";
import JobApplicationModal from "../../components/JobApplicationModal/JobApplicationModal";
import { useParams } from "react-router-dom";
import { useLanguage } from "../../Context/LanguageContext";
import { useQuery } from "@tanstack/react-query";
import Loader from "../../components/Loader/Loader";
import arrowRight from "../../assets/utility_images/arrow-right.svg";
import arrowRightWhite from "../../assets/utility_images/arrow-right-white.svg";

const InteropEngineer = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  return (
    <div>
      <Container fluid style={{ paddingLeft: 0, paddingRight: 0 }}>
        <section className="privacy-policy-section">
          <div className="privacy-policy">
            {/* Render the first section separately */}

            <div className="policy-description">
              <div className="privacy-heading">
                JD403: Interop Engineer (C++/CLI)
              </div>
              <div className="job-description">
                We are looking for Interop Engineer to support integration between native C++ processing engines and .NET-based applications for the Tube Inspection System. The role involves wrapper development, API integration, and system interoperability support.
              </div>

              <div className="value-header mt-4">
                Experience Level: 3 to 4 years
              </div>
            </div>

            {/* Render the other sections */}

            <div className="policy-description">
              <div className="value-header mt-4">Key Responsibilities</div>
              <div className="job-description">
                <ul>
                  <li>
                    Development of C++/CLI wrappers for native engine integration. 
                  </li>
                  <li>
                    Integration between C++ processing modules and C# applications. 
                  </li>
                  <li>
                    Development of data exchange and interoperability support modules. 
                  </li>
                  <li>
                    API integration and communication handling.
                  </li>
                  <li>
                    Support for system-level integration and debugging. 
                  </li>
                  <li>
                    Performance optimization and stability improvements for interop layers.
                  </li>
                </ul>
              </div>
              <div className="value-header mt-4">
                Required Skills & Qualifications
              </div>
              <div className="job-description">
                <ul>
                  <li>
                    Strong programming experience in C++, C++/CLI, and C#.
                  </li>

                  <li>Experience in System Integration and API Integration.</li>

                  <li>Understanding of interop technologies between native and managed applications.</li>

                  <li>
                    Knowledge of DLL integration and data exchange mechanisms.
                  </li>
                  <li>
                    Experience with desktop application integration is preferred.
                  </li>
                  <li>
                    B.Tech / B.E in CS/IT/ECE with CGPA 7.5 +.
                  </li>
                </ul>
              </div>

              <button
                className="btn-job  d-flex justify-content-evenly align-items-center"
                onClick={handleShow} // Show modal on click
              >
                Apply
                <div className="hero-btn">
                  <img
                    className="hover-arrow"
                    src={arrowRight}
                    alt=""
                    loading="lazy"
                  />
                  <img
                    className="hover-arrow-white"
                    src={arrowRightWhite}
                    alt=""
                    loading="lazy"
                  />
                </div>
              </button>
            </div>
          </div>
        </section>
      </Container>
      <JobApplicationModal show={show} handleClose={handleClose} />
    </div>
  );
};

export default InteropEngineer;
